import React from 'react';
import PropTypes from 'prop-types';
import {
  List,
  ListItem,
  ListItemText,
  Chip,
  Typography,
  Stack,
  Divider,
  Box,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import WifiRoundedIcon from '@mui/icons-material/WifiRounded';
import { getTypeColor } from '@/utils/nodeTypeMapper';

const DataStreamDetailList = ({ dataStreams, nodeType }) => {
  if (!dataStreams || dataStreams.length === 0) return null;

  const color = getTypeColor(nodeType) || '#1976d2';

  return (
    <Stack spacing={1} height="100%">
      {/* Header row */}
      <Stack direction="row" alignItems="center" spacing={0.75} sx={{ px: 1 }}>
        <WifiRoundedIcon
          sx={{
            fontSize: 18,
            transform: 'rotate(45deg)',
            color,
            opacity: 0.8,
          }}
        />
        <Typography variant="subtitle2" fontWeight={600}>
          Tilknyttede datakilder
        </Typography>
        <Chip
          size="small"
          label={dataStreams.length}
          sx={{
            height: 18,
            ml: 0.5,
            '& .MuiChip-label': {
              px: 0.75,
              fontSize: 11,
              lineHeight: '18px',
            },
          }}
        />
      </Stack>

      {/* Data list */}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          maxHeight: 400, // optional cap
        }}
      >
        <List disablePadding dense>
          {dataStreams.map((stream, index) => (
            <React.Fragment key={stream.UnitId}>
              <ListItem
                disableGutters
                sx={{
                  py: 0.5,
                  px: 1.5,
                  borderRadius: 1.5,
                  border: `1px solid`,
                  borderColor: 'divider',
                  // backgroundColor: alpha(color, 0.03),
                  // '&:hover': {
                  //   backgroundColor: alpha(color, 0.05),
                  // },
                }}
              >
                <ListItemText
                  primary={
                    <Typography variant="body2" fontWeight={600} noWrap>
                      {stream.Name}
                    </Typography>
                  }
                  secondary={
                    <Chip
                      size="small"
                      label={`ID #${stream.UnitId}`}
                      sx={{
                        mt: 0.25,
                        borderRadius: 1,
                        borderColor: alpha(color, 0.4),
                        '& .MuiChip-label': { px: 0.75 },
                      }}
                      variant="outlined"
                    />
                  }
                />
              </ListItem>
              {index < dataStreams.length - 1 && (
                <Divider variant="middle" sx={{ my: 0.25, opacity: 0.3 }} />
              )}
            </React.Fragment>
          ))}
        </List>
      </Box>
    </Stack>
  );
};

DataStreamDetailList.propTypes = {
  dataStreams: PropTypes.arrayOf(
    PropTypes.shape({
      UnitId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      Name: PropTypes.string.isRequired,
    }),
  ),
  nodeType: PropTypes.string,
};

export default DataStreamDetailList;
